/**
 * @generated SignedSource<<08e97cdcbbff76053bb34a2678b283da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TierType = "LITE" | "PRO" | "CORE" | "ENTERPRISE" | "TRIAL" | "FREE_FOREVER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FeatureFlagsPage_viewer$data = {
  readonly component: string | null;
  readonly id: string;
  readonly missionControlData: {
    readonly id: string;
    readonly companies: ReadonlyArray<{
      readonly id: string;
      readonly companyId: number | null;
      readonly name: string | null;
      readonly tier: TierType | null;
      readonly accessBlocked: boolean | null;
      readonly betaOptIn: boolean | null;
    } | null> | null;
    readonly forecastPersons: ReadonlyArray<{
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
    } | null> | null;
    readonly otherPersons: ReadonlyArray<{
      readonly id: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
      readonly companyId: string;
    } | null> | null;
    readonly availableFeatures: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null;
      readonly key: string | null;
      readonly team: string | null;
      readonly rolledOut: boolean | null;
      readonly restrictive: boolean | null;
      readonly companyOnly: boolean | null;
      readonly rolledOutDate: string | null;
      readonly cleanedUp: boolean | null;
      readonly createdAt: string | null;
      readonly enabledForAllCompanies: boolean | null;
      readonly enabledForAllCompaniesAt: string | null;
      readonly enabledForAllCompaniesBy: string | null;
      readonly companies: ReadonlyArray<{
        readonly id: string;
        readonly companyId: string;
        readonly name: string | null;
        readonly timestamp: string | null;
      } | null> | null;
      readonly persons: ReadonlyArray<{
        readonly id: string;
        readonly personId: string;
        readonly companyId: string;
        readonly companyName: string | null;
        readonly name: string | null;
        readonly email: string | null;
        readonly timestamp: string | null;
      } | null> | null;
      readonly personsOptedOut: ReadonlyArray<{
        readonly id: string;
        readonly companyId: string;
        readonly name: string | null;
      } | null> | null;
    } | null> | null;
    readonly featureFlagLists: {
      readonly id: string;
      readonly cohorts: ReadonlyArray<{
        readonly id: string;
        readonly cohortId: number | null;
        readonly name: string | null;
        readonly companyIds: ReadonlyArray<number | null> | null;
      } | null> | null;
      readonly alwaysLastCompanyIds: ReadonlyArray<number | null> | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
  readonly " $fragmentType": "FeatureFlagsPage_viewer";
};
export type FeatureFlagsPage_viewer$key = {
  readonly " $data"?: FeatureFlagsPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeatureFlagsPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeatureFlagsPage_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "control_feature_flags"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"control_feature_flags\")"
    },
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MissionControlHeader_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlCompanyType",
          "kind": "LinkedField",
          "name": "companies",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tier",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "accessBlocked",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "betaOptIn",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlImpersonatePersonType",
          "kind": "LinkedField",
          "name": "forecastPersons",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlImpersonatePersonType",
          "kind": "LinkedField",
          "name": "otherPersons",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailableFeaturesType",
          "kind": "LinkedField",
          "name": "availableFeatures",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "team",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rolledOut",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "restrictive",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyOnly",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rolledOutDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cleanedUp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabledForAllCompanies",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabledForAllCompaniesAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "enabledForAllCompaniesBy",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyFeatureType",
              "kind": "LinkedField",
              "name": "companies",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonFeatureType",
              "kind": "LinkedField",
              "name": "persons",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "personId",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyName",
                  "storageKey": null
                },
                (v2/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PersonFeatureType",
              "kind": "LinkedField",
              "name": "personsOptedOut",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MissionControlFeatureFlagListsType",
          "kind": "LinkedField",
          "name": "featureFlagLists",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "MissionControlFeatureFlagCohortType",
              "kind": "LinkedField",
              "name": "cohorts",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cohortId",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyIds",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "alwaysLastCompanyIds",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "3f0a4f18abc1d063a16f56def23d5130";

export default node;
